import request from '@/utils/request.js'

export function detailInfo(params) {
  return request({
    url: '/detail/info',
    method: 'get',
    params: params
  })
}
